import { Marketplace } from '@/enums/marketplace';
import { InvalidMarketplaceException } from '@/exceptions/invalid-marketplace.exception';

const MARKETPLACE_VALUES = new Set(Object.values(Marketplace));
export const SUPPORTED_RUNTIME_MARKETPLACES = [Marketplace.Wb, Marketplace.Ozon] as const;
const RUNTIME_MARKETPLACE_VALUES = new Set<string>(SUPPORTED_RUNTIME_MARKETPLACES);

export type RuntimeSupportedMarketplace = (typeof SUPPORTED_RUNTIME_MARKETPLACES)[number];

export const isMarketplace = (value: string): value is Marketplace => {
    return MARKETPLACE_VALUES.has(value as Marketplace);
};

export const isRuntimeSupportedMarketplace = (value: string): value is RuntimeSupportedMarketplace => {
    return RUNTIME_MARKETPLACE_VALUES.has(value);
};

export const resolveMarketplaceOrThrow = (platform: string): Marketplace => {
    if (!isMarketplace(platform)) {
        throw new InvalidMarketplaceException(platform);
    }

    return platform;
};

export const resolveRuntimeSupportedMarketplaceOrThrow = (platform: string): RuntimeSupportedMarketplace => {
    if (!isRuntimeSupportedMarketplace(platform)) {
        throw new InvalidMarketplaceException(platform);
    }

    return platform;
};
